var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content",attrs:{"id":"app"}},[_c('h5',[_vm._v("此版本：1.0.0")]),_c('Navbar'),_c('router-view'),_vm._l((10),function(index){return _c('br',{key:index})}),_c('div',{staticClass:"wrapper"},[_c('Footer')],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }